import { ImageSizeSelector } from '@/components/nodes/image/image-size-selector';

type SizeItemProps = {
  id: string;
  value: string;
  options: string[];
  notes?: Record<string, string>;
  onChange: (value: string) => void;
  disabled?: boolean;
  width?: number | string | 'auto';
};

export function SizeItem({ id, value, options, notes, onChange, disabled, width = 'auto' }: SizeItemProps) {
  return (
    <ImageSizeSelector
      id={id}
      value={value}
      options={options}
      notes={notes}
      onChange={onChange}
      disabled={disabled}
      width={width}
      className="rounded-xl h-9"
    />
  );
}


